import React from "react";
import "../css/ready.css";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { SlUser, SlBell } from "react-icons/sl";

const MainHeader = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  // Get the current logged-in user's name
  const account = instance.getAllAccounts()[0];
  const userName = account ? account.name : "User";
  const userRole = account?.idTokenClaims?.roles?.[0] || "User";

  const location = useLocation();

  // Define route-to-title mapping
  const routeTitles = {
    "/dashboard": "Dashboard",
    "/inventory": "Inventory",
    "/capacity": "Capacity Planning",
    "/replication": "Replication Status",
    "/teams": "Teams",
    "/initiatedr": "Initiate DR",
    "/runbook": "Run Book",
    "/kubernetes": "Kubernetes",
    "/dbbackup": "DB Backup",
  };

  // Get the title based on the current route
  const currentTitle = routeTitles[location.pathname] || "Welcome";

  const handleLogout = () => {
    instance
      .logoutPopup()
      .then(() => {
        sessionStorage.removeItem("isAuthenticated");
        localStorage.removeItem("provider");
        navigate("/"); // Redirect to login page after logout
      })
      .catch((error) => {
        console.error("Logout failed: ", error);
      });
  };
  return (
    <div className="main-header">
      <div className="logo-header"></div>
      <nav className="navbar navbar-header navbar-expand-lg bg-white border-bottom-0">
        <div className="container-fluid row">
          <div className="col-md-4">
            <form
              className="navbar-left navbar-form nav-search mr-md-3"
              action=""
            >
              <p className="fs-6 mb-0 fw-bold">{currentTitle}</p>
            </form>
          </div>
          <div className="col-md-8">
            <div className="d-flex align-items-center justify-content-end">
              {/* <button className="btn bg-blue-500 text-dark w-50 mx-auto"> */}
              {/* <Link
                to="/"
                className="d-flex align-items-center justify-content-center text-dark"
              >
                <SlShuffle className="fs-5 me-4" />
             
              </Link> */}        
              {/* </button> */}       

              <SlBell className="fs-5 me-2" />

              <div className="dropdown profile-dropdown">
                <div
                  className="btn dropdown-toggle d-flex align-items-center"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="rounded-circle me-2 w-40 h-40 border d-flex justify-content-center align-items-center">
                    <SlUser />
                  </div>

                  <p className="mb-0">{userName}</p>
                </div>

                <div className="dropdown-menu p-0 rounded">
                  <div className="card border-0 p-0 w-18 mb-0">
                    <div className="card-body p-0">
                      <div className="row m-0 mt-3 p-0 align-items-center">
                        <div className="col-10 m-0">
                          <h6 className="card-title m-0">{userName}</h6>
                          <p className="card-subtitle mb-2 text-muted m-0">
                            {userRole}
                          </p>
                        </div>
                      </div>

                      <div className="list-group m-0">
                        <Link
                          to="#"
                          className="list-group-item border-0 list-group-item-action"
                        >
                          <i className="far fa-user me-3"></i>Profile
                        </Link>
                      </div>
                      <div className="dropdown-divider m-0"></div>
                      <button
                        onClick={handleLogout}
                        className="list-group-item border-0 list-group-item-action text-danger rounded"
                      >
                        <i className="fas fa-power-off me-3"></i>Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MainHeader;
